import { PrimaryButton } from "components/Button/Button"
import { SvgIcons } from "components/Icon/Icon"
import { BodyText } from "components/Typography/Typography"
import type { Instance } from "mobx-state-tree"
import type { ErrorModel } from "models/common/OperationStatus"
import styled from "styled-components"

const Container = styled.div`
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2em;
`

type ErrorScreenProps = {
  /*
    Handle JS errors and `ErrorModel` 
  */
  error: Error | Instance<typeof ErrorModel>
  errorMessagePrefix: string
  onRetry?: () => Promise<void>
}

export const ErrorScreen = ({
  error,
  errorMessagePrefix,
  onRetry,
}: ErrorScreenProps) => {
  return (
    <Container>
      <SvgIcons.ErrorSvg />
      <BodyText>
        {errorMessagePrefix}: {error.message}{' '}
      </BodyText>
      {onRetry && <PrimaryButton text="Try Again" onClick={() => { void onRetry() }} />}
    </Container>
  )
}

export default ErrorScreen